<!-- 批次管理 -->
<template>
    <div class="container">
        <div class="header">
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.name"
                clearable
                placeholder="请输入批次名称"
            ></Input>
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="ios-search"
                @click="goSearch"
                >确认搜索</Button
            >
        </div>
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goModal(1)"
                    >新增批次</Button
                >
                <Table
                    ref="selection"
                    :columns="columnsTable"
                    :data="dataTable"
                    border
                    @on-selection-change="changeSelection"
                >
                    <template slot-scope="{ row }" slot="template_type">
                        <div @click="goModal(3, row)">
                            <Button v-if="row.diy_template" type="success">{{
                                row.diy_template.title
                            }}</Button>
                            <Button v-else>选择模板</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="show_report_imgs">
                        <div class="flex-c" @click="goReport(row)">
                            <Button
                                v-if="row.show_report_imgs.length"
                                type="success"
                                ghost
                                >已添加（{{
                                    row.show_report_imgs.length
                                }}）</Button
                            >
                            <Button v-else>未添加</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="attribute_count">
                        <div class="flex-c" @click="goAttribute(row)">
                            <Button
                                v-if="row.attribute_count"
                                type="success"
                                ghost
                                >已添加({{ row.attribute_count }})</Button
                            >
                            <Button v-else>未添加</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="is_voice">
                        <div class="flex-c">
                            <i-switch
                                v-model="row.is_voice"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="2"
                                @on-change="changeIsVoice(row, $event)"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost @click="goMyCode(row)"
                                >预览溯源码</Button
                            >
                            <Button
                                type="primary"
                                ghost
                                @click="goModal(1, row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(1, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox
                        class="checkbox-ml"
                        v-model="del_value"
                        @on-change="handleSelectAll"
                        >全选</Checkbox
                    >
                    <span class="mr24 ml24"
                        >已经选择{{ delData.length }}个</span
                    >
                    <Button type="error" ghost @click="goDel(0)">删除</Button>
                </div>
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增或修改批次 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            :width="modalWidth"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formData"
                    label-position="right"
                    :label-width="160"
                >
                    <FormItem label="批次名称：">
                        <Input
                            class="w200"
                            type="text"
                            v-model="formData.batch_name"
                            placeholder="请输入批次名称"
                        ></Input>
                    </FormItem>
                    <FormItem label="语音播报：">
                        <i-switch
                            v-model="formData.is_voice"
                            size="large"
                            true-color="#FF761D "
                            :true-value="1"
                            :false-value="2"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>
                    <FormItem label="最大查询数：">
                        <Input
                            class="w200"
                            type="number"
                            v-model="formData.max_query"
                            placeholder="请输入最大查询数"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D "
                            />
                            <div slot="content"><p>0则不限制查询次数</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="是否强制关注服务号：">
                        <i-switch
                            v-model="formData.is_follow_wechat"
                            size="large"
                            true-color="#FF761D "
                            :true-value="1"
                            :false-value="0"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D "
                            />
                            <div slot="content">
                                <p>需检查系统设置内公众号是否配置</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="选择模板：">
                        <Button @click="goModal(2, formData)">
                            <span v-if="formData.template_id">{{
                                itemData.template_title
                                    ? itemData.template_title
                                    : "选择模板"
                            }}</span>
                            <span v-else>选择模板</span>
                        </Button>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D "
                            />
                            <div slot="content">
                                <p>
                                    选择模板后，该批次的溯源码将优先使用此模板
                                </p>
                            </div>
                        </Tooltip>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 选择模板 -->
        <Modal
            v-model="template_modal"
            title=" "
            width="60"
            :mask-closable="false"
        >
            <div>
                <Menu
                    mode="horizontal"
                    :active-name="formData.template_type"
                    @on-select="selectTemplate"
                >
                    <MenuItem name="1">产品模板</MenuItem>
                    <MenuItem name="2">DIY模版</MenuItem>
                </Menu>
                <Table
                    class="mt24"
                    :columns="columnsTemplate"
                    :data="dataTemplate"
                    border
                >
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <template v-if="formData.template_id == row.id">
                                <div class="theme-color">使用中</div>
                                <Button
                                    type="error"
                                    ghost
                                    @click="changeUsed(row)"
                                    >取消</Button
                                >
                            </template>
                            <Button
                                v-else
                                type="primary"
                                ghost
                                @click="useTemplate(row)"
                                >使用</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="page-div">
                    <Page
                        :current="storeTemplate.page"
                        :page-size="storeTemplate.limit"
                        :total="totalTemplate"
                        show-elevator
                        show-total
                        @on-change="pageChangeTemplate"
                    />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- myCode -->
        <Drawer
            v-model="is_code"
            :title="drawerTitle"
            width="80"
            :transfer="false"
        >
            <myCode :codeData="codeData"></myCode>
        </Drawer>
        <!-- 质检报告 -->
        <Modal
            v-model="reportModal"
            title="质检报告"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="reportData"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="质检报告：">
                        <Input
                            type="text"
                            v-model="reportData.report_name"
                            placeholder="请输入质检报告名称"
                        ></Input>
                        <div class="mt24">
                            <div class="form_upload mb24" @click="openModal(1)">
                                <Icon
                                    type="ios-add"
                                    size="40"
                                    color="#AEAEB3"
                                />
                            </div>
                            <draggable
                                class="dragg_div"
                                v-model="itemData.show_report_imgs"
                                chosen-class="chosen"
                                force-fallback="true"
                                group="people"
                                animation="500"
                                :handle="'.dragg'"
                                @start="onStart"
                                @end="onEnd"
                            >
                                <div
                                    v-for="(
                                        item, index
                                    ) in itemData.show_report_imgs"
                                    :key="index"
                                >
                                    <div
                                        class="form_upload mr24 mb24 position_relative dragg"
                                    >
                                        <Icon
                                            class="form_icon"
                                            size="20"
                                            type="ios-close-circle"
                                            color="#f00"
                                            @click.stop="delImg(index)"
                                        />
                                        <img
                                            class="width_height_100"
                                            :src="item"
                                        />
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelReportModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitReportModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 批次属性 -->
        <Drawer
            v-model="attributeModal"
            title="批次属性"
            width="50"
            :transfer="false"
        >
            <div class="attr-container">
                <Form label-position="left" :label-width="100">
                    <div
                        v-for="(item, index) in attrPageData"
                        :key="index"
                        class="attr-content"
                    >
                        <img
                            src="@/assets/del_attr.png"
                            class="attr-del"
                            @click="delAttribute(index)"
                        />
                        <FormItem label="批次属性：" class="w90">
                            <div class="dis-flex-c">
                                <Select
                                    label-in-value
                                    v-model="item.attribute_id"
                                    clearable
                                    filterable
                                    placeholder="请选择批次属性"
                                    @on-change="changeAttribute(index, $event)"
                                >
                                    <Option
                                        v-for="it in attributeList"
                                        :value="it.id"
                                        :key="it.id"
                                        >{{ it.name }}</Option
                                    >
                                </Select>
                            </div>
                        </FormItem>
                        <FormItem v-if="item.attribute_name" class="w90 mt12">
                            <div class="dis-flex-c">
                                <template
                                    v-if="name_style && name_value == item.id"
                                >
                                    <Input
                                        type="text"
                                        v-model="item.attribute_name"
                                        placeholder="属性名称"
                                    ></Input>
                                    <Button
                                        type="primary"
                                        ghost
                                        class="ml24"
                                        @click="editNameStyle1(item)"
                                        >确定</Button
                                    >
                                </template>
                                <template v-else>
                                    <div>{{ item.attribute_name }}</div>
                                    <img
                                        src="@/assets/edit_name.png"
                                        class="ml24 cursor-pointer"
                                        @click="editNameStyle2(item)"
                                    />
                                </template>
                            </div>
                        </FormItem>
                        <FormItem class="w90 mt12">
                            <div
                                v-for="(ite, inde) in item.attribute_content"
                                :key="inde"
                            >
                                <div
                                    class="flex-sb mb12 position_relative width_100"
                                >
                                    <Input
                                        class="w30"
                                        type="text"
                                        v-model="ite.content_id"
                                        placeholder="批次属性名称"
                                    ></Input>
                                    <!-- 图片 -->
                                    <div v-if="ite.attribute_type == 6">
                                        <div
                                            class="form-upload"
                                            @click="openModal(2, index, inde)"
                                        >
                                            <img
                                                v-if="ite.attribute_content"
                                                class="form-img"
                                                :src="ite.attribute_content"
                                            />
                                            <div v-else class="flex-c form-img">
                                                <img
                                                    src="@/assets/upload_val.png"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 复选框 -->
                                    <CheckboxGroup
                                        v-model="ite.attribute_content"
                                        v-else-if="ite.attribute_type == 5"
                                        class="w50"
                                    >
                                        <Checkbox
                                            v-for="(
                                                item, index
                                            ) in ite.select_list"
                                            :value="item"
                                            :key="index"
                                            :label="item"
                                        ></Checkbox>
                                    </CheckboxGroup>
                                    <!-- 单选框 -->
                                    <RadioGroup
                                        v-model="ite.attribute_content"
                                        v-else-if="ite.attribute_type == 4"
                                        class="w50"
                                    >
                                        <Radio
                                            v-for="(
                                                item, index
                                            ) in ite.select_list"
                                            :value="item"
                                            :key="index"
                                            :label="item"
                                        ></Radio>
                                    </RadioGroup>
                                    <!-- 下拉框 -->
                                    <Select
                                        v-else-if="ite.attribute_type == 3"
                                        v-model="ite.attribute_content"
                                        class="w50"
                                    >
                                        <Option
                                            v-for="(
                                                item, index
                                            ) in ite.select_list"
                                            :value="item"
                                            :key="index"
                                            >{{ item }}</Option
                                        >
                                    </Select>
                                    <!-- textarea -->
                                    <Input
                                        v-else-if="ite.attribute_type == 2"
                                        class="w50"
                                        type="textarea"
                                        v-model="ite.attribute_content"
                                        :placeholder="
                                            ite.attribute_tips
                                                ? ite.attribute_tips
                                                : '请输入'
                                        "
                                    ></Input>
                                    <Input
                                        v-else
                                        class="w50"
                                        type="text"
                                        v-model="ite.attribute_content"
                                        :placeholder="
                                            ite.attribute_tips
                                                ? ite.attribute_tips
                                                : '请输入'
                                        "
                                    ></Input>
                                    <Icon
                                        class="cursor-p"
                                        v-if="item.attribute_content.length > 1"
                                        type="ios-close-circle-outline"
                                        color="#FF4838"
                                        size="24"
                                        @click="
                                            delAttributeContent(
                                                inde,
                                                item.attribute_content
                                            )
                                        "
                                    />
                                </div>
                            </div>
                            <Button
                                class="theme-bc theme-default-color"
                                icon="md-add-circle"
                                @click="
                                    addAttributeContent(item.attribute_content)
                                "
                                >添加</Button
                            >
                        </FormItem>
                    </div>
                    <Button
                        class="theme-bc theme-default-color"
                        icon="md-add-circle"
                        @click="addAttribute"
                        >添加批次属性</Button
                    >
                </Form>
            </div>
            <div class="footer-btn">
                <Button @click="cancelAttributeModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color ml12"
                    @click="submitAttributeModal"
                    >确定</Button
                >
            </div>
        </Drawer>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import {
    batch_list,
    batch_delete,
    batch_info,
    template_result_template,
    template_diy_list,
    batch_save,
    batch_change,
    batch_attr_list,
    batch_add_attribute,
    product_attribute_content_list,
    batch_reports,
    batch_change_template,
    product_attribute_select,
} from "@/api/index";
import myCode from "@/components/myCode/myCode.vue";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import draggable from "vuedraggable";
export default {
    components: { myCode, pictureLibrary, draggable },
    data() {
        return {
            srctype: "",
            srctype_index: "",
            srctype_inde: "",
            select: 1,
            select_type: "image",
            switch_modal: false,
            drawerTitle: "",
            itemData: {
                template_title: "",
                report_imgs: [],
                show_report_imgs: [],
            },
            is_code: false,
            storePrams: {
                page: 1,
                limit: 10,
                name: "",
            },
            total: 0,
            columnsTable: [
                { type: "selection", width: 60, align: "center" },
                { type: "index", width: 60, align: "center" },
                { title: "批次ID", key: "id", align: "center" },
                { title: "批次名称", key: "batch_name", align: "center" },
                { title: "最大查询数", key: "max_query", align: "center" },
                { title: "使用模板", slot: "template_type", align: "center" },
                {
                    title: "质检报告",
                    slot: "show_report_imgs",
                    align: "center",
                },
                { title: "批次属性", slot: "attribute_count", align: "center" },
                { title: "语音播报", slot: "is_voice", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ],
            dataTable: [],
            modals: false,
            template_modal: false,
            modalTitle: "",
            modalWidth: "",
            formData: {
                id: "",
                batch_name: "",
                is_voice: 2,
                max_query: "",
                template_type: "1",
                template_id: "",
                is_follow_wechat: 0,
            },
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            infoId: "",
            storeTemplate: {
                page: 1,
                limit: 10,
                industry_id: -1,
            },
            totalTemplate: 0,
            columnsTemplate: [
                { type: "index", width: 60, align: "center" },
                { title: "ID", key: "id", align: "center" },
                { title: "模板名称", key: "title", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataTemplate: [],
            attributeModal: false,
            attributeData: {
                id: "",
                attribute: {},
            },
            name_style: false,
            name_value: "",
            attrPageData: [
                { attribute_id: "", attribute_name: "", attribute_content: [] },
            ],
            attributeList: [],
            reportModal: false,
            reportData: {
                id: "",
                report_name: "",
                report_imgs: "",
            },
            codeData: {},
            modal_value: 0,
            batch_id: "",
        };
    },
    mounted() {
        this.getList();
        // 批次属性下拉
        this.getAttributeSelect();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.srctype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.itemData.show_report_imgs.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.itemData.report_imgs.push(param2[i]);
                }
                this.$Message.destroy();
            } else if (this.srctype == 2) {
                for (var i = 0; i < param2.length; i++) {
                    this.attrPageData[this.srctype_index].attribute_content[
                        this.srctype_inde
                    ].attribute_content = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e, index, inde) {
            this.srctype = e;
            this.srctype_index = index;
            this.srctype_inde = inde;
            this.switch_modal = true;
        },
        // 移动时
        onStart(e) {
            this.drag = true;
            console.log("触发移动", e);
        },
        // 移动结束
        onEnd(e) {
            this.drag = false;
            console.log("移动结束", e);
        },
        goReport(row) {
            this.infoId = row.id;
            this.getInfo();
            this.reportData.id = row.id;
            setTimeout(() => {
                this.reportModal = true;
            }, 300);
        },
        cancelReportModal() {
            this.reportModal = false;
        },
        submitReportModal() {
            this.reportData.report_imgs = this.itemData.report_imgs.join(",");
            batch_reports(this.reportData)
                .then((res) => {
                    this.getList();
                    this.reportModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        delImg(index) {
            this.itemData.report_imgs.splice(index, 1);
            this.itemData.show_report_imgs.splice(index, 1);
        },
        addAttributeContent(item) {
            item.push({
                content_id: "",
                attribute_content: "",
                attribute_tips: "请输入",
                attribute_type: 1,
            });
        },
        delAttributeContent(index, e) {
            e.splice(index, 1);
        },
        getAttributeSelect() {
            product_attribute_select()
                .then((res) => {
                    this.attributeList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        changeAttribute(i, event) {
            if (event) {
                this.attrPageData[i].attribute_name = event.label;
                product_attribute_content_list({ id: event.value })
                    .then((res) => {
                        var data = res.data;
                        data = res.data.map((item) => ({
                            content_id: item.attribute_name,
                            attribute_content: item.attribute_val,
                            attribute_tips: item.attribute_tips,
                            attribute_type: item.attribute_type,
                            attribute_val: item.attribute_val,
                            type_val: item.type_val,
                            select_list: item.type_val
                                ? item.type_val.split("*")
                                : [],
                        }));
                        this.attrPageData[i].attribute_content = data;
                    })
                    .catch((err) => {
                        this.$Message.error(err.msg);
                    });
            } else {
                this.attrPageData[i].attribute_name = "";
                this.attrPageData[i].attribute_content = [
                    {
                        attribute_content: "",
                        attribute_tips: null,
                        attribute_type: 1,
                        content_id: "",
                        attribute_val: "",
                        type_val: "",
                    },
                ];
            }
        },
        editNameStyle1(item) {
            this.name_value = item.id;
            this.name_style = false;
        },
        editNameStyle2(item) {
            this.name_value = item.id;
            this.name_style = true;
        },
        addAttribute() {
            this.attrPageData.push({
                attribute_id: "",
                attribute_name: "",
                attribute_content: [],
            });
        },
        delAttribute(index) {
            this.attrPageData.splice(index, 1);
        },
        goAttribute(row) {
            this.infoId = row.id;
            this.batch_attr_list();
            this.attributeData.id = row.id;
            setTimeout(() => {
                this.attributeModal = true;
            }, 300);
        },
        batch_attr_list() {
            batch_attr_list({ id: this.infoId })
                .then((res) => {
                    if (res.data.length) {
                        this.attrPageData = res.data;
                    } else {
                        this.attrPageData = [
                            {
                                attribute_id: "",
                                attribute_name: "",
                                attribute_content: [],
                            },
                        ];
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        cancelAttributeModal() {
            this.attributeModal = false;
        },
        submitAttributeModal() {
            this.attributeData.attribute = this.attrPageData;
            batch_add_attribute(this.attributeData)
                .then((res) => {
                    this.getList();
                    this.attributeModal = false;
                    this.name_style = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        getList() {
            batch_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageChangeTemplate(index) {
            this.storeTemplate.page = index;
            if (this.formData.template_type == 1) {
                this.getTemplateList();
            } else if (this.formData.template_type == 2) {
                this.getDiyList();
            }
        },
        changeIsVoice(row, e) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变语音播报状态吗？",
                onOk: () => {
                    batch_change({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
        // 详情
        getInfo() {
            batch_info({ id: this.infoId })
                .then((res) => {
                    this.formData.id = res.data.id;
                    this.formData.batch_name = res.data.batch_name;
                    this.formData.is_voice = res.data.is_voice;
                    this.formData.max_query = res.data.max_query;
                    this.formData.template_type = res.data.template_type + "";
                    this.formData.template_id = res.data.template_id;
                    this.formData.is_follow_wechat = res.data.is_follow_wechat;
                    this.itemData.template_title = res.data.template.title;
                    if (res.data.report_imgs) {
                        this.itemData.report_imgs =
                            res.data.report_imgs.split(",");
                    } else {
                        this.itemData.report_imgs = [];
                    }
                    this.itemData.show_report_imgs = res.data.show_report_imgs;
                    this.reportData.report_name = res.data.report_name;
                    this.reportData.report_imgs = res.data.report_imgs;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 模板列表
        getTemplateList() {
            template_result_template(this.storeTemplate)
                .then((res) => {
                    this.dataTemplate = res.data.data;
                    this.totalTemplate = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getDiyList() {
            template_diy_list(this.storeTemplate)
                .then((res) => {
                    this.dataTemplate = res.data.data;
                    this.totalTemplate = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        selectTemplate(name) {
            this.formData.template_type = name;
            if (name == 1) {
                this.getTemplateList();
            } else if (name == 2) {
                this.getDiyList();
            }
        },
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 0) {
                        var del_id = [];
                        this.delData.forEach((item) => {
                            del_id.push(item.id);
                        });
                        this.del_id = del_id.join(",");
                        batch_delete({ id: this.del_id })
                            .then((res) => {
                                this.getList();
                                this.del_value = false;
                                this.$Message.success(res.msg);
                            })
                            .catch((err) => {
                                this.$Message.error(err.msg);
                            });
                    } else if (index == 1) {
                        batch_delete({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((err) => {
                                this.$Message.error(err.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        useTemplate(row) {
            if (this.modal_value == 3) {
                this.$Modal.confirm({
                    title: "提示",
                    content: "确认改变使用状态吗？",
                    onOk: () => {
                        const data = {
                            batch_id: this.batch_id,
                            template_id: row.id,
                            template_type: this.formData.template_type,
                        };
                        batch_change_template(data)
                            .then((res) => {
                                this.getList();
                                this.template_modal = false;
                                this.$Message.success(res.msg);
                            })
                            .catch((err) => {
                                this.$Message.error(err.msg);
                            });
                    },
                    onCancel: () => {},
                });
            } else {
                this.$Modal.confirm({
                    title: "提示",
                    content: "确认改变使用状态吗？",
                    onOk: () => {
                        this.formData.template_id = row.id;
                        this.itemData.template_title = row.title;
                        this.template_modal = false;
                    },
                    onCancel: () => {},
                });
            }
        },
        changeUsed(row) {
            if (this.modal_value == 3) {
                console.log("row", row);
                this.$Modal.confirm({
                    title: "提示",
                    content: "确认取消使用状态吗？",
                    onOk: () => {
                        const data = {
                            batch_id: this.batch_id,
                            template_id: 0,
                            template_type: this.formData.template_type,
                        };
                        batch_change_template(data)
                            .then((res) => {
                                this.getList();
                                this.template_modal = false;
                                this.$Message.success(res.msg);
                            })
                            .catch((err) => {
                                this.$Message.error(err.msg);
                            });
                    },
                    onCancel: () => {},
                });
            } else {
                this.$Modal.confirm({
                    title: "提示",
                    content: "确认取消使用状态吗？",
                    onOk: () => {
                        this.formData.template_id = 0;
                        this.itemData.template_title = row.title;
                        this.template_modal = false;
                    },
                    onCancel: () => {},
                });
            }
        },
        goModal(index, row) {
            this.modal_value = index;
            if (index == 1) {
                if (row) {
                    this.modalTitle = "编辑批次";
                    this.modalWidth = 600;
                    this.infoId = row.id;
                    this.getInfo();
                } else {
                    this.modalTitle = "新增批次";
                    this.modalWidth = 600;
                    this.infoId = "";
                    this.formData.id = "";
                    this.formData.batch_name = "";
                    this.formData.is_voice = 2;
                    this.formData.max_query = "";
                    this.formData.template_type = "1";
                    this.formData.template_id = "";
                    this.formData.is_follow_wechat = 0;
                }
                setTimeout(() => {
                    this.modals = true;
                }, 300);
            } else if (index == 2) {
                if (this.formData.template_type == 1) {
                    this.getTemplateList();
                } else if (this.formData.template_type == 2) {
                    this.getDiyList();
                }
                setTimeout(() => {
                    this.template_modal = true;
                }, 300);
            } else if (index == 3) {
                this.batch_id = row.id;
                this.formData.template_type = row.template_type + "";
                this.formData.template_id = row.template_id;
                if (row.template_type == 1) {
                    this.getTemplateList();
                } else if (row.template_type == 2) {
                    this.getDiyList();
                }
                setTimeout(() => {
                    this.template_modal = true;
                }, 300);
            }
        },
        cancelModal() {
            this.modals = false;
        },
        // 确定
        submitModal() {
            if (!this.formData.batch_name) {
                this.$Message.error("请输入批次名称");
                return;
            }
            batch_save(this.formData)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
        goMyCode(row) {
            this.codeData = row;
            this.is_code = true;
            this.drawerTitle = "溯源码";
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.page-div {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.form-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #eee;
    border-radius: 4px;
    cursor: pointer;
}
.form-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.form_upload {
    width: 70px;
    height: 70px;
    background: #ffffff;
    border-radius: 5px;
    border: 1px dashed #9fa5bb;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dragg_div {
    display: flex;
    flex-wrap: wrap;
}
.form_icon {
    position: absolute;
    top: -10px;
    right: -10px;
    pointer-events: auto !important; /* 确保可点击 */
}
.width_height_100 {
    width: 100%;
    height: 100%;
}
.position_relative {
    position: relative;
}
.width_100 {
    width: 100%;
}
.checkbox-ml {
    margin-left: 20px !important;
}
.cursor-p {
    cursor: pointer;
}
.attr-container {
    height: 80vh;
    overflow-y: auto;
}
.attr-content {
    margin-bottom: 12px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    position: relative;
}
.attr-del {
    position: absolute;
    top: 0;
    right: 0;
    width: 48px;
    height: 48px;
    cursor: pointer;
}
.w90 {
    width: 90%;
}
.dis-flex-c {
    display: flex;
    align-items: center;
}
.cursor-pointer {
    cursor: pointer;
}
.w50 {
    width: 50%;
}
.w30 {
    width: 30%;
}
.footer-btn {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 24px;
    background-color: #fff;
    width: 100%;
    text-align: right;
    border-top: 1px solid #ccc;
}
.attr-content ::v-deep .ivu-form-item {
    margin-bottom: 0 !important;
}
::v-deep .ivu-menu.ivu-menu-light.ivu-menu-horizontal {
    display: flex;
    align-items: center;
    justify-content: space-around;
}
::v-deep .ivu-menu-item {
    font-size: 16px;
}
::v-deep .ivu-menu-item:hover {
    font-size: 16px;
    color: #ff761d !important;
    border-bottom: 2px solid #ff761d !important;
}
::v-deep .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    font-size: 16px;
    color: #ff761d;
    border-bottom: 2px solid #ff761d !important;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
/* RadioGroup */
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: #ff761d;
}
::v-deep .ivu-radio-inner:after {
    background-color: #ff761d;
}
</style>